<template>
  <div>
    <multiselect
      class="form-control"
      v-model="modelo.idsede"
      :options="datos"
      track-by="id"
      label="nombre"
      :searchable="false"
      :close-on-select="true"
      :show-labels="false"
      :hide-selected="true"
      placeholder="Seleccione la sede..."
    ></multiselect>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  export default {
    props: {
      model: Object,
      tosedes: { type: Object, required: false, default: null },
      default: { type: Object, required: false, default: null },
      bycargos: { type: Boolean, required: false, default: false },
    },
    data() {
      return {
        // datos: [],
        app_name: process.env.VUE_APP_NAME,
        modelo: {
          idsede: null,
        },
      };
    },
    watch: {
      'modelo.idsede': function() {
        this.model.idsede = this.modelo.idsede;
        this.$store.state.CARGO.sede.id = this.modelo.idsede.id;
        this.$emit('reloadprogramas');
      },
      default: function(a) {
        if (a == null) return;
        this.modelo.idsede = a;
      },
      '$store.state.CARGO': function() {
        let xidsede = this.$store.state.CARGO.idsede;
        let xsede = this.datos.find((x) => x.id == xidsede);
        //this.default = {};
        const vue = this;
        setTimeout(function() {
          vue.default = xsede;
        }, 300);
        this.filteCargos();
      },
    },
    computed: {
      ...mapState({
        datos: (state) =>
          state.UNIDAD_NEGOCIO_ID
            ? state.modsede.items.filter((item) => item.unidad_negocio == state.UNIDAD_NEGOCIO_ID)
            : [],
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      }),
    },
    methods: {
      filteCargos() {
        if (!this.bycargos) return;
        var ff = [];
        this.$store.state.CARGOS.forEach(function(e) {
          ff.push({ id: e.idsede, nombre: e.nombre });
        });
        this.datos = ff;
      },
    },
  };
</script>
